import React, {useState} from "react"

import PropTypes from "prop-types"
import {Field} from "redux-form"
import {Select} from "semantic-ui-react"

import SemanticFormField from "../SemanticFormField/semanticFormField"

/**
 * Un select avec autocompletion restreinte sur le préfix des options
 */
const SearchSelectByPrefixField = ({options, ...props}) => {
    const [searchQuery, setSearchQuery] = useState("")

    // Permet de filtrer les options dont la recherche est un préfix
    const searchByPrefix = (options, query) => {
        const q = query.toLowerCase()

        return options.filter(opt => opt.text.toLowerCase().startsWith(q))
    }

    // Permet d'ignorer toute valeur n'etant pas le préfix d'une des options
    const handleSearchChange = (e, {searchQuery}) => {
        const normalized = searchQuery.toLowerCase()
        const isValidPrefix = options.some(opt => opt.text.toLowerCase().startsWith(normalized))

        if (isValidPrefix || normalized === "") {
            setSearchQuery(searchQuery)
        }
    }

    // Permet de reset la recherche lors de la selection d'une option
    const handleChange = () => {
        setSearchQuery("")
    }

    // Permet d'empêcher Semantic UI de clear la valeur lors du blur
    const handleBlur = e => {
        e.preventDefault()
    }

    return (
        <Field
            as={Select}
            component={SemanticFormField}
            onBlur={handleBlur}
            onChange={handleChange}
            onSearchChange={handleSearchChange}
            options={options}
            search={searchByPrefix}
            searchQuery={searchQuery}
            {...props}
        />
    )
}

SearchSelectByPrefixField.propTypes = {
    options: PropTypes.array.isRequired,
}

export default SearchSelectByPrefixField
